<div class="st-dialog-about-body">
    <div class="st-dialog-about-body-logo ap-logo"></div>
    <div class="st-dialog-about-body-label">{{ productLabel }}</div>
    <div class="st-dialog-about-body-version">{{ languageSettings.PSTWebDialogAboutPlatformLabel }}&nbsp;{{ app_version }}</div>
    <div
        *ngIf="hasErrors"
        class="st-dialog-about-body-error"
        (click)="downloadErrors()">
        {{ languageSettings.PSTWebDialogAboutDownloadErrorLog }}
    </div>
    <div class="st-dialog-about-body-rights">{{ '&copy; Associated Press. All rights reserved.' }}</div>
</div>
<button
    mat-button
    class="st-dialog-about-button"
    mat-dialog-close
    (click)="closeDialog()">
    {{ languageSettings.PSTWebDialogAboutCloseLabel }}
</button>
